import {
  Directive,
  HostBinding,
  Input
} from '@angular/core';

import { FormGroupService } from './form-group.service';


@Directive({
  selector: '[bsFormGroup]',
  exportAs: 'bs-form-group',
  providers: [FormGroupService]
})
export class FormGroupDirective {
  @HostBinding('class.form-group') formClass: boolean = true;

  @HostBinding('class.has-danger')
  @Input() hasError: boolean = false;

  @HostBinding('class.has-success')
  @Input() hasSuccess: boolean = false;
}
